import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BsDatepickerModule } from 'ngx-bootstrap';

import { CoreModule } from './@core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginModule } from './login/login.module';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { OwlModule } from 'ngx-owl-carousel'
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ForemanPowerbiReportComponent } from './foreman-powerbi-report/foreman-powerbi-report.component'

@NgModule({
  declarations: [AppComponent, TermsConditionComponent, ForemanPowerbiReportComponent],
  imports: [CommonModule, AppRoutingModule, CoreModule.forRoot(), 
    BsDatepickerModule.forRoot(), LoginModule,OwlModule,CarouselModule],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
